import api from './api';

const batchService = {
  getAllBatches: async (params = {}) => {
    const response = await api.get('/batches', { params });
    return response.data;
  },

  getRunningBatches: async () => {
    const response = await api.get('/batches/running');
    return response.data;
  },

  getBatchById: async (id) => {
    const response = await api.get(`/batches/${id}`);
    return response.data;
  },

  getBatchStats: async (id) => {
    const response = await api.get(`/batches/${id}/stats`);
    return response.data;
  },

  getBatchStudents: async (id) => {
    const response = await api.get(`/batches/${id}/students`);
    return response.data;
  },

  createBatch: async (data) => {
    const response = await api.post('/batches', data);
    return response.data;
  },

  updateBatch: async (id, data) => {
    const response = await api.put(`/batches/${id}`, data);
    return response.data;
  },

  updateBatchStatus: async (id, status) => {
    const response = await api.patch(`/batches/${id}/status`, { status });
    return response.data;
  },

  deleteBatch: async (id) => {
    const response = await api.delete(`/batches/${id}`);
    return response.data;
  },
};

export default batchService;
